import React, { FC } from 'react';
import { Label } from '@atlaskit/form';
import Select from '@atlaskit/select';

import { DEFAULT_GROUPING_VALUE_LABEL, GROUPING_OPTIONS } from '../constants';

type Props = {
    onChange: (value: string) => void;
    value: string;
    label?: string;
};

const GroupingSelect: FC<Props> = ({ value, onChange, label }) => {
    return (
        <div>
            {label && <Label htmlFor='mlv-field-grouping-select'>{label}</Label>}
            <Select
                options={GROUPING_OPTIONS}
                onChange={selectedOption => onChange(selectedOption?.value || '')}
                value={GROUPING_OPTIONS.find(option => option.value === value)}
                isClearable={false}
                id='mlv-field-grouping-select'
                testId='mlv-field-grouping-select'
                defaultValue={DEFAULT_GROUPING_VALUE_LABEL}
            />
        </div>
    );
};

export default GroupingSelect;
